import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import type { FormControl } from '@angular/forms';

import type { User } from '@core/account-types';
import { AdminsAvatarsComponent } from '@core/account-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { FormFieldComponent, LabelComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-admins-form-control',
  templateUrl: './evaluation-admins-form-control.component.html',
  styleUrl: './evaluation-admins-form-control.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, FormFieldComponent, LabelComponent, AdminsAvatarsComponent],
})
export class EvaluationAdminsFormControlComponent {
  public readonly control = input.required<FormControl<User[]>>();
  public readonly editable = input<boolean>(false);

  public readonly editAssignments = output<void>();
}
